import React from "react";

export default function DateTimeTableCell({ id,className,children,childSwitch }) {
    // Filtere nur Inhalte, die sinnvoll sind (nicht leer, keine Leerzeichen, kein null/undefined)
    const validChildren = React.Children.toArray(children).filter(
        (child) => typeof child === "string" && child.trim() !== "" // prüft auf Strings ohne Leerzeichen
    );

    let content = "";
    if (validChildren.length === 1) {
        try {
            content = new Date(validChildren[0]).toLocaleString(undefined, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                // second wird weggelassen
            });
        } catch (e) {
            content = "Invalid date";
        }
    }
    return (
        <td key={id} className={`border px-4 py-2 text-nowrap text-end${className ? " " + className : ""}`}>
            {childSwitch} {content}
        </td>

    );
}
